import { useCallback } from 'react';
import useTombFinance from './useTombFinance';
import { AutoCompounder } from '../tomb-finance';

const useHarvestAutoCompounder = (bank: AutoCompounder) => {
  const tombFinance = useTombFinance();

  const handleHarvest = useCallback(async () => {
    try {
      await tombFinance.harvestAutoCompounder(bank);
    } catch (error) {
      console.error(error);
      // You might want to show an error message to the user
    }
  }, [tombFinance, bank]);

  return { onHarvest: handleHarvest };
};

export default useHarvestAutoCompounder; 